import { useAuthStore } from '@/stores'
import Config from '../config'

export const FetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    delete: request('DELETE')
}

function request(method) {
    return (url, body, headers = null) => {
        const requestOptions = {
            method,
            headers: authHeader(url)
        }
        requestOptions.headers['Content-Type'] = 'application/json'
        if (headers !== null) {
            requestOptions.headers = Object.assign(requestOptions.headers, headers)
        }
        if (body) {
            requestOptions.body = JSON.stringify(body)
        }
        return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(error => {
            console.error('fetch error', error)
        })
    }
}

function authHeader(url) {
    const { user } = useAuthStore()
    const isLoggedIn = !!user?.token
    const isApiUrl = url.startsWith(Config.BASE_URL) || url.startsWith(Config.TOKEN_URL)
    if (isLoggedIn && isApiUrl) {
        return { 'Authorization': 'Bearer ' + user.token }
    }
    // Fix for API gateway issue when unauthenticated
    return { 'Authorization': 'Bearer' }
}

async function handleResponse(response) {
    if (!response.ok) {
        const { logout } = useAuthStore()
        if ([401, 403, 502].includes(response.status)) {
            // auto logout if 401 Unauthorized or
            // 403 Forbidden response returned from API
            logout()
        }
        return Promise.reject(response)
    }

    const { login } = useAuthStore()
    const bearerToken = response.headers?.get('Authorization')
    // This looks to be now deprecated
    if (bearerToken) {
        login(bearerToken)
    }

    const isJson = response.headers?.get('content-type')?.includes('application/json')
    const data = isJson ? await response.json() : {}
    return data
}
